module.exports = __webpack_public_path__ + "img/05.921b532a.png";